import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  styleUrls: ['./FutureReturns.component.css'],
  selector: 'FutureReturns',
  templateUrl: './FutureReturns.component.html',
})
export class FutureReturnsComponent extends PageBase {
  constructor(el: ElementRef) {
    super(el, "OnewayFutureReturnReport");
  }
}
